import { createAction } from "redux-actions";

export const USER_SELECTS_REPORT_BOOK = "USER_SELECTS_REPORT_BOOK";
export const userSelectsReportBook = createAction(USER_SELECTS_REPORT_BOOK);
